import { BooleanDisplayComponent } from 'app/driver-pay/persistence/core/components/displays/BooleanDisplay.component';
import { BooleanInputComponent } from 'app/driver-pay/persistence/core/components/inputs/BooleanInput.component';
import { IsoInstantAsLocalDateTimeDisplayComponent } from 'app/driver-pay/persistence/core/components/displays/IsoInstantAsLocalDateTimeDisplay.component';
import { InstantAsLocalDatetimeInputComponent } from 'app/driver-pay/persistence/core/components/inputs/InstantAsLocalDatetimeInput.component';
import { LocalDateDisplayComponent } from 'app/driver-pay/persistence/core/components/displays/LocalDateDisplay.component';
import { DateInputComponent } from 'app/driver-pay/persistence/core/components/inputs/DateInput.component';
import { EnumInputComponent } from 'app/driver-pay/persistence/core/components/inputs/EnumInput.component';
import {
  EnumContextDirective,
  EnumDisplayComponent,
} from 'app/driver-pay/persistence/core/components/displays/EnumDisplay.component';
import { NumberInputComponent } from 'app/driver-pay/persistence/core/components/inputs/NumberInput.component';
import { MtrOption } from '@mortar/angular/components/core';
import { IsoInstantAsLocalTimeDisplayComponent } from 'app/driver-pay/persistence/core/components/displays/IsoInstantAsLocalTimeDisplay.component';
import { InstantAsLocalTimeInputComponent } from 'app/driver-pay/persistence/core/components/inputs/InstantAsLocalTimeInput.component';
import { IsoInstantAsLocalTimeNoTzDisplayComponent } from 'app/driver-pay/persistence/core/components/displays/IsoInstantAsLocalTimeNoTzDisplay.component';
import { FieldComponents } from 'app/driver-pay/persistence/core/components/managers/Field.component';
import { InstantAsLocalDatetimeWithinWeekEndDateComponent } from './timekeeping/InstantAsLocalDatetimeWithinWeekEndDate.component';
import { DateWithinWeekEndDateComponent } from './timekeeping/DateWithinWeekEndDate.component';
import { UsdDisplayComponent } from 'app/driver-pay/persistence/core/components/displays/UsdDisplay.component';
import { NumberDisplayComponent } from 'app/driver-pay/persistence/core/components/displays/NumberDisplay.component';
import { IntegerDisplayComponent } from 'app/driver-pay/persistence/core/components/displays/IntegerDisplay.component';
import { NumberDisplayBlankIfZeroComponent } from '../core/components/displays/NumberDisplayBlankIfZero.component';
import { UsdDisplayBlankIfZeroComponent } from '../core/components/displays/UsdDisplayBlankIfZero.component';

export const BOOLEAN_FIELD_COMPONENTS: FieldComponents = {
  read: BooleanDisplayComponent,
  write: BooleanInputComponent,
};

export const ISO_INSTANT_WITHIN_WEEK_END_DATE_FIELD_COMPONENTS: FieldComponents = {
  read: IsoInstantAsLocalDateTimeDisplayComponent,
  write: InstantAsLocalDatetimeWithinWeekEndDateComponent,
};

export const LOCAL_DATE_WITHIN_WEEK_END_DATE_FIELD_COMPONENTS: FieldComponents = {
  read: LocalDateDisplayComponent,
  write: DateWithinWeekEndDateComponent,
};

export const ISO_INSTANT_FIELD_COMPONENTS: FieldComponents = {
  read: IsoInstantAsLocalDateTimeDisplayComponent,
  write: InstantAsLocalDatetimeInputComponent,
};

export const LOCAL_DATE_FIELD_COMPONENTS: FieldComponents = {
  read: LocalDateDisplayComponent,
  write: DateInputComponent,
};

export const LOCAL_TIME_FIELD_COMPONENTS: FieldComponents = {
  read: IsoInstantAsLocalTimeDisplayComponent,
  write: InstantAsLocalTimeInputComponent,
};

export const LOCAL_TIME_NO_TZ_FIELD_COMPONENTS: FieldComponents = {
  read: IsoInstantAsLocalTimeNoTzDisplayComponent,
  write: InstantAsLocalTimeInputComponent,
};

export const INTEGER_FIELD_COMPONENTS: FieldComponents = {
  read: IntegerDisplayComponent,
  write: NumberInputComponent,
};

export const NUMBER_FIELD_COMPONENTS: FieldComponents = {
  read: NumberDisplayComponent,
  write: NumberInputComponent,
};

export const USD_FIELD_COMPONENTS: FieldComponents = {
  read: UsdDisplayComponent,
  write: NumberInputComponent,
};

export const NUMBER_BLANK_IF_ZERO_FIELD_COMPONENTS: FieldComponents = {
  read: NumberDisplayBlankIfZeroComponent,
  write: NumberInputComponent,
};

export const USD_BLANK_IF_ZERO_FIELD_COMPONENTS: FieldComponents = {
  read: UsdDisplayBlankIfZeroComponent,
  write: NumberInputComponent,
};

export const ENUM_FIELD_COMPONENTS: (options: MtrOption[]) => FieldComponents = (options: MtrOption[]) => {
  const enumContext = new EnumContextDirective();
  enumContext.options = options;
  return {
    read: EnumDisplayComponent,
    write: EnumInputComponent,
    providers: [
      {
        provide: EnumContextDirective,
        useValue: enumContext,
      },
    ],
  };
};

export const ACTIVITY_EXCLUSION_FREQUENCY_ENUM_OPTIONS: MtrOption[] = [
  {
    label: 'Week',
    value: 'WEEK',
  },
  {
    label: 'Always',
    value: 'ALWAYS',
  },
  {
    label: 'Day',
    value: 'DAY',
  },
  {
    label: 'Segment',
    value: 'SEGMENT',
  },
  {
    label: 'Trip',
    value: 'TRIP',
  },
];

export const ACTIVITY_RATE_CALCULATION_METHOD_ENUM_OPTIONS: MtrOption[] = [
  {
    label: 'Delay',
    value: 'DELAY',
  },
  {
    label: 'Flat rate',
    value: 'FLAT_RATE',
  },
  {
    label: 'Flat rate per mile',
    value: 'FLAT_RATE_PER_MILE',
  },
  {
    label: 'Location rate',
    value: 'LOCATION_RATE',
  },
  {
    label: 'Mileage',
    value: 'MILEAGE_RATE',
  },
  {
    label: 'None/hard-coded',
    value: 'NA',
  },
];

export const RATE_UNIT_TYPE_ENUM_OPTIONS: MtrOption[] = [
  {
    label: 'Units',
    value: 'UNITS',
  },
  {
    label: 'Hours',
    value: 'HOURS',
  },
  {
    label: 'Miles',
    value: 'MILES',
  },
  {
    label: 'Dollars',
    value: 'DOLLARS',
  },
  {
    label: 'Relief miles',
    value: 'RELIEF_MILES',
  },
];

export const TRIP_EVENT_ENUM_OPTIONS: MtrOption[] = [
  {
    label: 'Trip',
    value: 'TRIP',
  },
  {
    label: 'Stop',
    value: 'STOP',
  },
  {
    label: 'Segment',
    value: 'SEGMENT',
  },
  {
    label: 'Debrief Action',
    value: 'DEBRIEF_ACTION',
  },
  {
    label: 'N/A',
    value: 'NA',
  },
];

export const FACILITY_TYPE_ENUM_OPTIONS: MtrOption[] = [
  {
    label: 'Backhaul',
    value: 'BACKHAUL',
  },
  {
    label: 'Other Stop',
    value: 'OTHER_STOP',
  },
  {
    label: 'Region Terminal',
    value: 'REGION_TERMINAL',
  },
  {
    label: 'Store',
    value: 'STORE',
  },
  {
    label: 'Terminal',
    value: 'TERMINAL',
  },
  {
    label: 'Warehouse',
    value: 'WAREHOUSE',
  },
];

export const WEEKDAY_ENUM_OPTIONS: MtrOption[] = [
  {
    label: 'Monday',
    value: 'MONDAY',
  },
  {
    label: 'Tuesday',
    value: 'TUESDAY',
  },
  {
    label: 'Wednesday',
    value: 'WEDNESDAY',
  },
  {
    label: 'Thursday',
    value: 'THURSDAY',
  },
  {
    label: 'Friday',
    value: 'FRIDAY',
  },
  {
    label: 'Saturday',
    value: 'SATURDAY',
  },
  {
    label: 'Sunday',
    value: 'SUNDAY',
  },
];

export const EARN_CODE_ENUM_OPTIONS: MtrOption[] = [
  {
    value: 'ATN',
    label: 'ATN: WMT Attendance Day',
  },
  {
    value: 'CP1',
    label: 'CP1: Frisco CSA/Curbie GO',
  },
  {
    value: 'DIS',
    label: 'DIS: Disaster Pay to Schedule',
  },
  {
    value: 'DPP',
    label: 'DPP: Premium Pay',
  },
  {
    value: 'DS2',
    label: 'DS2: DIS for PHE',
  },
  {
    value: 'DSM',
    label: 'DSM: Driver Safety Miles',
  },
  {
    value: 'FNL',
    label: 'FNL: Funeral Leave',
  },
  {
    value: 'HOL',
    label: 'HOL: Company Holiday',
  },
  {
    value: 'ILL',
    label: 'ILL: Medbank',
  },
  {
    value: 'INJ',
    label: 'INJ: Injury Leave',
  },
  {
    value: 'JUR',
    label: 'JUR: Jury Duty',
  },
  {
    value: 'LVC',
    label: 'LVC: Vacation In Lieu Of',
  },
  {
    value: 'LHL',
    label: 'LHL: Company Holiday In-Lieu Of',
  },
  {
    value: 'PHD',
    label: 'PHD: Partner Holiday',
  },
  {
    value: 'RDR',
    label: 'RDR: Relief Driver',
  },
  {
    value: 'REG',
    label: 'REG: Regular',
  },
  {
    value: 'SAF',
    label: 'SAF: WMT Safety Day',
  },
  {
    value: 'VAC',
    label: 'VAC: Vacation',
  },
];

export const NON_ACTIVITY_CALCULATION_METHOD_ENUM_OPTIONS: MtrOption[] = [
  {
    label: 'Hours at ADP Rate',
    value: 'HOURS',
  },
  {
    label: 'Miles',
    value: 'MILES',
  },
  {
    label: 'Hours at Fixed Rate',
    value: 'OVERRIDE_HOURLY_RATE',
  },
  {
    label: 'Fixed Dollar Amount',
    value: 'PAY_AMOUNT',
  },
  {
    label: 'Adjust to ADP for Day',
    value: 'UP_TO_ADP',
  },
  {
    label: 'None/hard-coded',
    value: 'NA',
  },
  {
    label: 'Penality Miles Incurred',
    value: 'PENALTY_MILES_INCURRED',
  },
  {
    label: 'Hours at Custom Rate',
    value: 'HOURS_AT_CUSTOM_RATE',
  },
];

export const CALCULATION_ADJUSTMENT_ENUM_OPTIONS: MtrOption[] = [
  {
    label: 'Bypass week for interval average',
    value: 'BYPASS_WEEK_FOR_INTERVAL_AVERAGE',
  },
  {
    label: 'Reset interval average',
    value: 'RESET_INTERVAL_AVERAGE',
  },
  {
    label: 'Reset consecutive safe miles',
    value: 'RESET_CONSECUTIVE_SAFE_MILES',
  },
  {
    label: 'Adjustment: miles',
    value: 'ADJUSTMENT_MILES',
  },
  {
    label: 'Adjustment: safe miles',
    value: 'ADJUSTMENT_SAFE_MILES',
  },
  {
    label: 'Adjustment: consecutive safe miles',
    value: 'ADJUSTMENT_CONSECUTIVE_SAFE_MILES',
  },
  {
    label: 'Adjustment: fixed dollar amount',
    value: 'ADJUSTMENT_FIXED_DOLLAR_AMOUNT',
  },
  {
    label: 'Adjustment: service hours',
    value: 'ADJUSTMENT_SERVICE_HOURS',
  },
  {
    label: 'Adjustment: non-activity hours',
    value: 'ADJUSTMENT_NON_ACTIVITY_HOURS',
  },
  {
    label: 'Adjustment: entitlement hours',
    value: 'ADJUSTMENT_ENTITLEMENT_HOURS',
  },
  {
    label: 'Adjustment: Eligible Dollars',
    value: 'ADJUSTMENT_ELIGIBLE_PAY',
  },
];

export const MOVE_TYPE_OPTIONS: MtrOption[] = [
  { label: 'Unknown', value: 'UNKNOWN' },
  { label: 'Backhaul', value: 'BACKHAUL' },
  { label: 'Backhaul', value: 'BKH' },
  { label: 'Load', value: 'L' },
  // { label: 'Load', value: 'LOAD' }, // not supported in Backend
  { label: 'Reverse Logistics Shipment', value: 'RLG' },
  { label: 'Reverse Logistics Shipment', value: 'REVERSE' },
  { label: 'Shipment', value: 'SHIPMENT' },
  { label: 'Shipment', value: 'SHP' },
  { label: 'Empty', value: 'EMPTY' },
  { label: 'Empty', value: 'E' },
];

export const STOP_ACTION_OPTIONS: MtrOption[] = [
  { label: 'Tandem break arrival', value: 'TANDEM_BREAK_ARRIVAL' },
  { label: 'Tandem break depart', value: 'TANDEM_BREAK_DEPART' },
  { label: 'Cancel appointment', value: 'CANCEL_APPOINTMENT' },
  { label: 'Deliver all', value: 'DELIVER_ALL' },
  { label: 'Deliver', value: 'DELIVER' },
  { label: 'Tandem join arrival', value: 'TANDEM_JOIN_ARRIVAL' },
  { label: 'Pickup all', value: 'PICKUP_ALL' },
  { label: 'Pick up', value: 'PICK_UP' },
  { label: 'Relay deliver', value: 'RELAY_DELIVER' },
  { label: 'Remove load', value: 'REMOVE_LOAD' },
  { label: 'Relay pickup', value: 'RELAY_PICKUP' },
  { label: 'Remove shipment', value: 'REMOVE_SHIPMENT' },
  { label: 'Tandem join depart', value: 'TANDEM_JOIN_DEPART' },
  { label: 'Unknown', value: 'UNKNOWN' },
];

export const USER_ROLE_ENUM_OPTIONS: MtrOption[] = [
  {
    label: 'Manager',
    value: 'MANAGER',
  },
  {
    label: 'Specialist',
    value: 'SPECIALIST',
  },
  {
    label: 'Terminal Leader',
    value: 'TERMINAL_LEADER',
  },
  {
    label: 'Regional Pay Clerk',
    value: 'REGIONAL_PAY_CLERK',
  },
  {
    label: 'Administrator',
    value: 'ADMINISTRATOR',
  },
  {
    label: 'Driver',
    value: 'DRIVER',
  },
  {
    label: 'Compensation Team',
    value: 'COMPENSATION_TEAM',
  },
];

export const CALCULATION_SCOPE_ENUM_OPTIONS: MtrOption[] = [
  { value: 'SHIFT', label: 'Shift' },
  { value: 'TRIP', label: 'Trip' },
  { value: 'CALCULATION_TRIP', label: 'Calculation Trip' },
  { value: 'DRIVER_NON_ACTIVITY', label: 'Driver Non-Activity' },
  { value: 'ACCIDENT', label: 'Accident' },
  { value: 'DISASTER', label: 'Disaster' },
  { value: 'DRIVER_DAY', label: 'Driver Day' },
  { value: 'DRIVER_WEEK', label: 'Driver Week' },
  { value: 'SUBMISSION', label: 'Submission' },
];

export const CALCULATION_STATUS_ENUM_OPTIONS: MtrOption[] = [
  { value: 'SUCCESS', label: 'Complete' },
  { value: 'CHANGE', label: 'Pending' },
  { value: 'ERROR', label: 'Error' },
  { value: 'CALCULATION', label: 'Calculation' },
];

export const ACTIVITY_JOB_CODE = '017706';
